<mat-dialog-content adEl>
  <p adEl>{{message}}</p>
</mat-dialog-content>
<mat-dialog-actions adEl>
  <button adEl="cancelButton" mat-button (click)="cancelAction()">
    Cancel
  </button>
  <button
    adEl="confirmButton"
    mat-raised-button
    color="warn"
    (click)="confirmAction()"
  >
    Confirm
  </button>
</mat-dialog-actions>
